import type { IHttpClientService } from "@/shared/services/http_client/interfaces/IHttpClientService.ts";
import type { ISystemRepository } from "@/app/system/interfaces/ISystemRepository";
import type { SystemModel } from "@/app/system/models/SystemModel";

export class SystemRepository implements ISystemRepository {
  private readonly URL: string = "/info";

  constructor(private readonly httpClientService: IHttpClientService) {}

  async getSystemInfo(): Promise<SystemModel> {
    return await this.httpClientService.get(`${this.URL}`);
  }
}
